import { render, staticRenderFns } from "./ItemsTransaction.vue?vue&type=template&id=acba034a&scoped=true"
import script from "./ItemsTransaction.vue?vue&type=script&lang=js"
export * from "./ItemsTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acba034a",
  null
  
)

export default component.exports